import { render, staticRenderFns } from "./lottery-popup.vue?vue&type=template&id=3a57a08a&scoped=true&"
import script from "./lottery-popup.vue?vue&type=script&lang=js&"
export * from "./lottery-popup.vue?vue&type=script&lang=js&"
import style0 from "./lottery-popup.vue?vue&type=style&index=0&id=3a57a08a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57a08a",
  null
  
)

export default component.exports